import React from 'react';
import ReactDOM from 'react-dom/client';
import 'core-js/es'  
import 'react-app-polyfill/ie9'  
import 'react-app-polyfill/stable'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

global.httpUrl='https://answer.51cywh.com/api/';
// global.httpUrl='http://127.0.0.1:81/api/';
// global.httpUrl='/api/';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
